import Service from "./Service"

class StorageLogService extends Service {

    search = (queryParams) => this.getWithParams("/storage-logs", queryParams)
}

const storageLogService = new StorageLogService()
export default storageLogService